import React, {useContext, useEffect, useState} from 'react';
import packageJson from './../../package.json';

const VersionContext = React.createContext<any>({});

const isLatestVersion = (rawBrowserVersion: any, rawRemoteVersion: any) => {
    const browserVersion = Number(rawBrowserVersion.replaceAll('.', '').replaceAll('-', ''));
    const remoteVersion = Number(rawRemoteVersion.replaceAll('.', '').replaceAll('-', ''));

    if (remoteVersion > browserVersion || isNaN(browserVersion)) return false;

    return true;
};

const VersionProvider = ({ children }: any) => {
    const [state, setState] = useState({
        isLoading: true,
        browserVersion: packageJson.version
    });

    const fetchBuildVersion = async () => {
        const { version } = await fetch('/meta.json').then(r => r.json());

        if (!isLatestVersion(state.browserVersion, version)) {
            if (caches) {
                caches.keys().then(keys => {
                    for (const key of keys) caches.delete(key);
                })
            }

            // @ts-ignore
            window.location.reload(true);
        }

        setState((state) => ({
            ...state,
            isLoading: false
        }));
    }

    useEffect(() => {
        fetchBuildVersion();
    }, []);

    return <VersionContext.Provider
        value={{
            version: state.browserVersion
        }}
    >
        { !state.isLoading && children }
    </VersionContext.Provider>
}

const useVersion = () => {
    const context = useContext(VersionContext);
    if (context === undefined) {
        throw new Error('useVersion must be used within a CountProvider');
    }

    return context;
}

export {
    VersionProvider,
    useVersion
}